var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ylAboutCompanyProfile"}},[(_vm.isMobileScreen)?_c('ylAboutCompanyProfileMobile',_vm._b({},'ylAboutCompanyProfileMobile',_vm.$attrs,false)):_c('ylAboutCompanyProfilePC',_vm._b({},'ylAboutCompanyProfilePC',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }